import * as React from "react";

import { IForm } from "../Engine/Form/IForm";
import { reject } from "../../../Common/TypingUtils";
import { IExternalEventManager } from "../Engine/Core/EventManagement/ExternalEvents/ExternalEventManager";
import { FormSettings } from "../Forms/Types/FormSettings";

const FormObjectContext = React.createContext<IForm | undefined>(undefined);

export function useFormObject(): IForm {
    return React.useContext(FormObjectContext) ?? reject("IForm object is no provided");
}

export function useFormSettings(): FormSettings {
    return useFormObject().settings;
}

export function useExternalEventManager(): IExternalEventManager {
    return React.useContext(FormObjectContext) ?? reject("IForm object is no provided");
}

interface FormObjectProviderProps {
    form: IForm;
    children: React.ReactNode;
}

export function FormObjectProvider(props: FormObjectProviderProps): JSX.Element {
    return <FormObjectContext.Provider value={props.form}>{props.children}</FormObjectContext.Provider>;
}
